import React from 'react'

import { Container, Content, Icon } from './styles'
import { Props } from './types'

const ListaDescricao = ({
  margin,
  alignAllItems,
  AlignOnlyLeftIcon,
  AlignOnlyRightIcon,
  iconLeft,
  iconRight,
  borderBottom,
  children,
  withBorder,
  borderColor,
  ...props
}: Props & React.HtmlHTMLAttributes<HTMLElement>) => (
  <Container
    margin={margin}
    borderBottom={borderBottom}
    alignItems={alignAllItems}
    withBorder={withBorder}
    borderColor={borderColor}
    data-testid="container"
    {...props}
  >
    <Icon left={!!iconLeft} align={AlignOnlyLeftIcon || alignAllItems} data-testid="left">
      {iconLeft}
    </Icon>

    <Content>{children}</Content>

    <Icon right={!!iconRight} align={AlignOnlyRightIcon || alignAllItems} data-testid="right">
      {iconRight}
    </Icon>
  </Container>
)

export default ListaDescricao
